import { render, staticRenderFns } from "./mediationCenter.vue?vue&type=template&id=0a084d81&scoped=true"
import script from "./mediationCenter.vue?vue&type=script&lang=js"
export * from "./mediationCenter.vue?vue&type=script&lang=js"
import style0 from "./mediationCenter.vue?vue&type=style&index=0&id=0a084d81&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a084d81",
  null
  
)

export default component.exports